// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"253":"2afaff7a","654":"2afaff7a","792":"a696d49f","812":"a696d49f"}[chunkId] + ".css";
};